var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueTelInputVuetify,{staticClass:"dropdown-telephone",attrs:{"id":"dropdown-telephone","label":"Enter a phone number","outlined":"","single-line":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }